import { Box, FieldSelect, Text } from '@dixa/lib-shared-habla';
import { MinimumIdentificationLevel } from 'lib-shared-legacy-types';
// eslint-disable-next-line no-restricted-imports
import { Field } from 'redux-form';

import { messengerSettingsFormFields } from 'components/settings/components/sections/dixaMessenger/views/appearance/types';

import {
  AnonymousDetails,
  ClaimedDetails,
  VerifiedDetails,
  VerifiedSettings,
} from './components';

type AuthOption = {
  id: MinimumIdentificationLevel;
  name: string;
};

const items: AuthOption[] = [
  {
    id: 'ANONYMOUS',
    name: 'Allow anonymous users',
  },
  {
    id: 'CLAIMED',
    name: 'Allow users to claim their identity',
  },
  {
    id: 'VERIFIED',
    name: 'Programmatically authenticate the users',
  },
];

type Props = {
  /** The messenger id. */
  messengerId: string;
  /** Minimum identification level. */
  minimumIdentificationLevel?: MinimumIdentificationLevel;
};

/** Authentication messenger settings. */
export function Authentication({
  messengerId,
  minimumIdentificationLevel,
}: Props): JSX.Element {
  return (
    <>
      <Text.Heading variant="heading-3">Request user identity</Text.Heading>

      <Box margin="300 0 0 0">
        <Field
          label="Select a method"
          component={FieldSelect}
          name={messengerSettingsFormFields.minimumIdentificationLevel}
          items={items}
        />
      </Box>

      {minimumIdentificationLevel === 'ANONYMOUS' && <AnonymousDetails />}
      {minimumIdentificationLevel === 'CLAIMED' && <ClaimedDetails />}
      {minimumIdentificationLevel === 'VERIFIED' && <VerifiedDetails />}

      <VerifiedSettings messengerId={messengerId} />
    </>
  );
}
